import React, { useCallback, useEffect, useRef, useState } from 'react'
import './AddNotes.scss'
import 'react-quill/dist/quill.snow.css';
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import EditorToolbar, { modules, formats }  from '../../../components/EditorToolbar/EditorToolbar'
import ReactQuill from 'react-quill';
import { CircularProgress, Switch, Tooltip } from '@mui/material';
import Select from "react-select";
import openEyeBtn from '../../../assets/images/eye-open.svg'
import closeEyeBtn from '../../../assets/images/eye-close.svg'
import { notify } from '../../../utils/notification';
import {addConsultationNotes, clearConsultationNotes, getNotesTypeList, getSessionListAgainstToNotes } from '../../../redux/actions/GuestDataActions/ConsultationNotesActions';
import ChangeVisibilityModal from '../../../components/ChangeVisibilityModal/ChangeVisibilityModal';
import UploadButton from '../../../components/UploadButton/UploadButton';
import { ADD, dynamicNotesType, nonSessionNotes, notesTypesName } from '../Forms/NoteFormsConstants';
import arrowImg from '../../../assets/images/arrow-up-white.svg'
import { getAnandaProgramsList } from '../../../redux/actions/ProgramActions/ProgramAction';
import backArrow from '../../../assets/images/back-arrow.svg'
import moment from 'moment';
import PDFExtractorOfLabTest from '../../../components/PDFExtractorOfLabTest/PDFExtractorOfLabTest';



function AddNotes() {
  const location = useLocation();
  const { guestId, userProgramId , date , guestName, sessionId, noteTypeName} = location.state;
  const UserData = JSON.parse(localStorage.getItem('UserData'))

  const [noteType, setNoteType] = useState('')
  const [session, setSession] = useState('')
  const [noteData, setNoteData] = useState('')
  const [eye, setEye] = useState(false)
  const [content, setContent] = useState('')
  const [files, setFiles] = useState({newFiles: [], uploadedFiles:[]})
  const [visibilityModal, setVisibilityModal] =useState(false)
  const [actionOnSubmit, setActionOnSubmit] = useState(undefined)
  const [actionOnReset, setActionOnReset] = useState(undefined)

  const dispatch = useDispatch()
  const navigate= useNavigate()
  const consultationNotesData = useSelector(state=> state.consultationNotesReducer)
  const permissions = JSON.parse(localStorage.getItem('UserData'))?.permissions;
  const canWriteNote = (permissions?.consultation_notes?.permissions || '').includes('write')
  const canWriteDietNote = (permissions?.dietary_notes?.permissions || '').includes('write')
  const isFirstSet = useRef(true);

  const handleProcedureContentChange = (content, delta, source, editor) => {
    editor.getHTML(); // rich text
    editor.getText(); // plain text
    editor.getLength(); // number of characters
    setContent(content);
  };

  const handleEye = ()=>{
    setEye(prev=> !prev);
    setVisibilityModal(false)
}

  const handleReset = ()=>{
    actionOnReset?.()
  }

  const handleSubmit = async()=>{
    if( !noteType || (!nonSessionNotes.includes(noteType?.label) && !session)){
      notify('warning', 'Please select the session')
    }else if(!content  || content?.replace?.(/<(.|\n)*?>/g, "")?.trim()?.length===0){
      notify('warning', 'Please fill the note content')
    }else{
      const finalContent = await actionOnSubmit?.() || content;
      dispatch(addConsultationNotes({
        guestId,
        userProgramId,
        sessionId: session?.value,
        isVisible: dynamicNotesType.find(item => item.title === noteType?.label) ? true : eye,
        content : dynamicNotesType.find(item => item.title === noteType?.label) ? JSON.stringify(finalContent) : finalContent,
        noteType: noteType?.label,
        files,
        date
      }))

    }
  }
  
  const scrollToTop = () => {
    const container = document.querySelector('.scrollable-fields');
    if (container) {
      container.scrollTo({
        top: 0,
        behavior: "smooth", // Smooth scrolling
      });
    }
  };

  const handleNoteChange=(e)=>{
    dispatch(clearConsultationNotes())
    let isJSONNote = dynamicNotesType.find(item => item.title === e?.label)
    setNoteData(isJSONNote)
    setNoteType(prev=>{
      if(isJSONNote){
        // if(isJSONNote.json["conducted_by"] !==undefined)
        //   isJSONNote.json["conducted_by"] = `${UserData.first_name} ${UserData.last_name}`

        
        setContent((JSON.parse(JSON.stringify(isJSONNote.json))))
      }
      else
        setContent('')
      if(isJSONNote?.hideVisibilityIcon)
        setEye(true)
      else
        setEye(false)
      setFiles({newFiles: [], uploadedFiles:[]})
      return e;
    })
  }

  const handleSessionChange=(e)=>{
    setSession(e)
    setContent(prev=>{
      if(content.conducted_by !==undefined){
        prev.conducted_by = e?.assigned_therapist || ''
      }
      return prev
    })
  }

  const handleBlur = useCallback(() => {
      setContent((prevText) => prevText);
  }, [content]);


  useEffect(()=>{
    dispatch(getNotesTypeList())
    dispatch(getAnandaProgramsList())
    if(noteTypeName){
      handleNoteChange({label: noteTypeName, value: noteTypeName})
      dispatch(getSessionListAgainstToNotes({userProgramId, noteType: noteTypeName}))
    }
  }, [])

  useEffect(()=>{
    if (consultationNotesData?.sessionList?.length && isFirstSet.current) {
      const found = consultationNotesData?.sessionList.find(
        (item) => item.session_id?.toString() === sessionId
      );
      if (found) {
        setSession({
          label: `${found.session_name} - ${moment(found.session_start_time).format("ddd, DD MMM YYYY")} | ${moment(found.session_start_time).format("hh:mm A")} `,
          value: found?.session_id,
          isRed: !found?.is_note_exist,
          ...found
        });
        isFirstSet.current = false; // prevent future runs
      }
    }
  }, [consultationNotesData.sessionList])




  return (
    <>
      <div className="add-notes-container">
        <div className="container h-100">
            <div className="add-notes-heading mt-4 d-flex align-items-center">
              <img className='back-arrow me-3' src={backArrow} width={'23px'} alt="" onClick={()=>navigate(-1)} />
              Consultant Recommendations
            </div>

            <div className="pt-4 pb-5">
              <div className="add-notes-content">
                <div className="d-flex justify-content-between align-items-center p-3">
                  <div className="heading">Add Note</div>
                  <div className='d-flex align-items-center'>
                    <button className='cancel' type='button' onClick={()=> navigate(-1)}>Cancel</button>
                      {/* {
                        noteData?.hasclear &&
                        <button className={`edit-btn me-2 ${  !actionOnReset ? '  opacity-25' : ''}`} disabled={!actionOnReset} type='submit' onClick={handleReset}>
                          Clear
                        </button>
                      }
                     */}
                    <button className="edit-btn" type='submit' onClick={handleSubmit}>
                      {
                        consultationNotesData?.updateLoader ?
                        <CircularProgress sx={{'color': '#fff'}} size={20}/>
                        :'Add'
                      }
                    </button>
                  </div>
                </div>
                <div className="form p-2 p-md-3 pt-0 pt-md-0">
                  <div className="scrollable-fields">
                    {
                      (()=>{
                        let isJSONNote = dynamicNotesType.find(item => item.title === noteType?.label)
                          let uploadComponent = isJSONNote?.hasAutoFillOption ?
                          <PDFExtractorOfLabTest
                          name={noteType?.label?.replace(/\s+/g, '') || 'default'}
                          files={files}
                          setFiles={setFiles}
                          className='mb-5'
                          setContent={setContent}
                        />

                        :<UploadButton
                            name={noteType?.label?.replace(/\s+/g, '') || 'default'}
                            files={files}
                            setFiles={setFiles}
                            className='mb-5'
                          />
                        return (
                          <>
                            <div className="d-flex flex-column-reverse align-items-center flex-md-row mb-3 justify-content-between border-bottom">
                              <div className="d-flex">
                                <div className='mb-3'>
                                  <div className='title mb-2 mt-4'>Select Session Category</div>
                                  <Select
                                      className="name-select"
                                      classNamePrefix="select"
                                      isClearable={true}
                                      isSearchable={true}
                                      isDisabled={true}
                                      name="color"
                                      styles={{
                                        container: (provided,state) => ({
                                            ...provided,
                                            width: "360px",
                                            
                                          }),
                                      }}
                                      value=  {noteType || null}

                                      options={
                                        [
                                          ...(consultationNotesData?.notesType ? consultationNotesData?.notesType?.filter(item=> item.title!==notesTypesName.EMOTIONAL_HEALING_NOTES)?.map(item=> ({
                                            label: item.title,
                                            value: item.title
                                          }))?.filter(item => (item.label !==notesTypesName.DIETRY_NOTES && canWriteNote) || (item.label ===notesTypesName.DIETRY_NOTES && canWriteDietNote)) : []),
                                        ]
                                      }
                                      placeholder='Select'
                                      onChange={handleNoteChange}
                                  />
                                </div>
                                {
                                  !nonSessionNotes.includes(noteType?.label) && 
                                  <div className='mb-3 ms-2'>
                                    <div className='title mb-2 mt-4'>Select Session</div>
                                    <Select
                                        className="name-select"
                                        classNamePrefix="select"
                                        isClearable={true}
                                        isSearchable={true}
                                        isLoading={consultationNotesData?.loadingSessionList}
                                        {...(session && { value: session })}
                                        name="color"
                                        styles={{
                                          container: (provided,state) => ({
                                              ...provided,
                                              width: "360px",
                                              
                                            }),
                                          option: (provided, state) => ({
                                            ...provided,
                                            color: state.isSelected ? (state.data.isRed? "#fb9292" : "white" ) : (state.data.isRed ? "red" : "black"),
                                          }),
                                          singleValue: (provided, state) => ({
                                            ...provided,
                                            color: state.data.isRed? "red" : "black" 
                                          }),
                                        }}
                                        options={
                                          [
                                            ...(consultationNotesData?.sessionList ? consultationNotesData?.sessionList?.map(item=> ({
                                              label: `${item.session_name} - ${moment(item.session_start_time).format("ddd, DD MMM YYYY")} | ${moment(item.session_start_time).format("hh:mm A")} `,
                                              value: item.session_id,
                                              isRed: !item.is_note_exist,
                                              ...item
                                            })) : [])
                                          ]
                                        }
                                        placeholder='Select'
                                        onChange={handleSessionChange}
                                    />
                                  </div>
                                }
                              </div>
                              {
                                noteType && !isJSONNote?.hideVisibilityIcon && noteType.label !=='Therapist Notes'   &&
                                <div style={{fontSize: 13}}>
                                  <span className={`${!eye ? 'fw-semi-bold': ''}`}>Hide</span>
                                  <Switch sx={{
                                    '& .MuiSwitch-switchBase.Mui-checked': {
                                      color: '#74613C',
                                    },
                                    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                                      backgroundColor: "#B4AB98",
                                    }
                                  }} 
                                  checked={eye} onChange={(e) => { setVisibilityModal(prev=> !prev) }} />
                                  <span className={`${eye ? 'fw-semi-bold': ''}`}>Visible</span>
                                </div>
                                // <div className='visible-btn d-flex align-items-center align-self-end' onClick={()=>setVisibilityModal(true)}>
                                // <img src={eye ? openEyeBtn : closeEyeBtn} alt="eye-btn" className="me-2 float-start"/>
                                //   <span className="title">{eye ? 'Visible to Guest' : 'Hidden from Guest'}</span>
                                // </div>
                              }
                            </div>
                            {
                              isJSONNote?
                              React.createElement(isJSONNote.component, {
                                content, 
                                setContent, 
                                setFiles,
                                type: isJSONNote.type, 
                                guestId, 
                                userProgramId, 
                                formType: ADD,
                                uploadComponent,
                                guestName,
                                conductedBy:  session?.assigned_therapist || '-',
                                actionOnReset,
                                setActionOnSubmit,
                                setActionOnReset
                              })
                              :
                              <div key={noteType?.label || '-'}>
                                {
                                  noteType && noteType.label !='Therapist Notes' &&
                                  <div className='text-danger border border-danger rounded py-2 fw-semi-bold mt-2 text-center mb-2'>
                                    THIS NOTE IS NOT AUTOMATICALLY VISIBLE TO THE GUEST. PLEASE TOGGLE THE ABOVE BUTTON TO MAKE IT VISIBLE
                                  </div>
                                }
                                <EditorToolbar />
                                <ReactQuill
                                  theme="snow"
                                  value={content}
                                  onChange={handleProcedureContentChange}
                                  onBlur={handleBlur}
                                  placeholder={noteType?.label ==='Therapist Notes' ? 'Recommendation for Therapist' : 'Enter Keywords ...'}
                                  formats={formats}
                                  modules={modules}
                                />
                                {uploadComponent}
                              </div>
                            }
                          </>
                        )
                      })()
                    }
                  </div>    
                </div>
                    
              </div>
            </div>
          </div>
          <button onClick={scrollToTop} className="scroll-to-top">
            <Tooltip  title="Move to top">
              <img src={arrowImg} style={{width: '15px'}} alt="" />
            </Tooltip>
          </button>
          <ChangeVisibilityModal
            warnModal={visibilityModal} 
            setWarnModal={setVisibilityModal} 
            onYes={handleEye}
            hide={eye}
          />
        </div>
      </>
  )
}

export default AddNotes